module.exports = __webpack_public_path__ + "static/media/howItWorks.f88fb581.jpg";